import { Button, ButtonProps, Spinner } from "@primer/react";

export interface IMButtonProps extends ButtonProps {
    /** Hiện spinner + disable nút khi đang xử lý (đăng ký / hủy / chốt). */
    loading?: boolean;
}

const SpinnerVisual = () => <Spinner size="small" />;

/**
 * Nút cho bản mobile — bọc thẳng Primer `Button` (không tự vẽ lại nút).
 * Chỉ thêm: ép touch target ≥ 44px và trạng thái `loading`.
 * Mọi prop Primer (`variant`, `block`, `leadingVisual`, `sx`...) đều dùng được như thường.
 */
const MButton = ({ loading, disabled, leadingVisual, sx, children, ...rest }: IMButtonProps) => (
    <Button
        {...rest}
        disabled={loading || disabled}
        leadingVisual={loading ? SpinnerVisual : leadingVisual}
        sx={{ minHeight: 44, ...sx }}
    >
        {children}
    </Button>
);

export default MButton;
